import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faKey, faChevronRight, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';

library.add(faEnvelope, faKey, faChevronRight, faArrowCircleRight);
